const reducer = {
  setFieldAppPackage(state, action) {
    const { field, value } = action.payload ?? {};
    if (field) {
      state[field] = value;
    }
  },
  addItemAppPackage(state, action) {
    if (state.list?.length >= 0) {
      state.list.Items.push(action.payload);
    }
  },
  removeItemAppPackage(state, action) {
    state.list.Items = state.list.Items.filter(
      (e) => e.Id !== action.payload?.Id,
    );
  },
};

export default reducer;
